export var timelineProps = {
    className: '',
    style: undefined,
    align: 'left',
};
export var timelineItemProps = {
    className: '',
    style: undefined,
    color: '',
    label: '',
    dot: null,
};
